"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var React = require("react");
var social_link_1 = require("../../shared/social_link");
var constants_1 = require("../../shared/constants");
var sanitized_render_1 = require("@reverbdotcom/commons/dist/components/sanitized_render");
var sale_search_bar_1 = require("../sale_search_bar");
var lodash_1 = require("lodash");
var moment = require('moment');
var _a = constants_1.default.SALE_BUYER_INELGIBILITY_REASONS, ENDED = _a.ENDED, NOT_STARTED = _a.NOT_STARTED, TIME_EXPIRED = _a.TIME_EXPIRED;
var SELLER = 'seller';
var CUSTOM = 'custom';
var DATE_FORMAT = 'MMMM Do';
var TIME_FORMAT = 'h:mm a';
var SaleInformation = /** @class */ (function (_super) {
    tslib_1.__extends(SaleInformation, _super);
    function SaleInformation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SaleInformation.prototype, "shopHref", {
        get: function () {
            return "/shop/" + this.props.sale.shop_slug;
        },
        enumerable: true,
        configurable: true
    });
    SaleInformation.prototype.dateTimeStringFor = function (dateTime) {
        var parsed = moment(dateTime);
        var date = parsed.format(DATE_FORMAT);
        var time = parsed.format(TIME_FORMAT);
        return I18n.t('discovery.saleInformation.dateAndTime', { date: date, time: time });
    };
    SaleInformation.prototype.linkFor = function (target) {
        var shareTarget = "share_" + target;
        return lodash_1.get(this.props, "socialLinks." + shareTarget + ".href");
    };
    Object.defineProperty(SaleInformation.prototype, "dateInfo", {
        get: function () {
            var sale = this.props.sale;
            if (sale.buyer_ineligibility_reason === ENDED ||
                sale.buyer_ineligibility_reason === TIME_EXPIRED) {
                return I18n.t('discovery.saleInformation.saleEnded', { dateTime: this.dateTimeStringFor(sale.ends_at) });
            }
            if (sale.buyer_ineligibility_reason === NOT_STARTED) {
                return I18n.t('discovery.saleInformation.saleBegins', { dateTime: this.dateTimeStringFor(sale.starts_at) });
            }
            if (sale.live && !sale.buyer_ineligibility_reason) {
                return I18n.t('discovery.saleInformation.saleEnds', { dateTime: this.dateTimeStringFor(sale.ends_at) });
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SaleInformation.prototype, "discountText", {
        get: function () {
            if (this.props.sale.show_code) {
                return I18n.t('discovery.saleInformation.discount', { percent: this.props.sale.discount_percent, code: this.props.sale.discount_code });
            }
            return I18n.t('discovery.saleInformation.discount_without_code', { percent: this.props.sale.discount_percent });
        },
        enumerable: true,
        configurable: true
    });
    SaleInformation.prototype.renderDate = function () {
        var dateInfo = this.dateInfo;
        if (!dateInfo) {
            return null;
        }
        return React.createElement(sanitized_render_1.default, { html: this.dateInfo });
    };
    SaleInformation.prototype.renderSafeDescription = function () {
        if (!this.props.description) {
            return null;
        }
        if (this.props.sale.sale_type === CUSTOM) {
            return null;
        }
        return (React.createElement(sanitized_render_1.default, { className: "sale-information__description", html: this.props.description }));
    };
    SaleInformation.prototype.renderDangerousDescription = function () {
        if (!this.props.description) {
            return null;
        }
        if (this.props.sale.sale_type !== CUSTOM) {
            return null;
        }
        return (React.createElement("div", { className: "sale-information__landing", dangerouslySetInnerHTML: { __html: this.props.description } }));
    };
    SaleInformation.prototype.renderShopInfo = function () {
        if (this.props.sale.sale_type !== SELLER) {
            return false;
        }
        return (React.createElement("div", { className: "sale-information__fineprint__shop-info" },
            I18n.t('discovery.saleInformation.createdBy'),
            React.createElement("b", null,
                React.createElement("a", { href: this.shopHref }, this.props.sale.shop_name))));
    };
    SaleInformation.prototype.render = function () {
        if (!this.props.sale) {
            return null;
        }
        return (React.createElement("aside", { className: "sale-information" },
            React.createElement("div", { className: "sale-information__inner" },
                React.createElement("div", { className: "sale-information__details" },
                    React.createElement("div", { className: "sale-information__discount" },
                        React.createElement(sanitized_render_1.default, { html: this.discountText })),
                    React.createElement("div", { className: "sale-information__fineprint__date-info" }, this.renderDate()),
                    this.renderSafeDescription()),
                React.createElement("div", { className: "sale-information__fineprint" },
                    React.createElement(sale_search_bar_1.default, { placeholder: I18n.t('discovery.saleInformation.searchPrompt'), location: this.props.location }),
                    React.createElement("aside", { className: "sale-information__fineprint__social" },
                        React.createElement(social_link_1.default, { link: this.linkFor('facebook'), type: "facebook" }),
                        React.createElement(social_link_1.default, { link: this.linkFor('twitter'), type: "twitter" }),
                        React.createElement(social_link_1.default, { link: this.linkFor('pinterest'), type: "pinterest" }),
                        React.createElement(social_link_1.default, { link: this.linkFor('email'), type: "email", icon: "envelope" })),
                    this.renderShopInfo())),
            this.renderDangerousDescription()));
    };
    return SaleInformation;
}(React.Component));
exports.default = SaleInformation;
//# sourceMappingURL=sale_information.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/sales/sale_information.js
// module id = RvAq
// module chunks = 20 21